import angular from 'angular';
import uiRouter from 'angular-ui-router';
import reportMapComponent from './reportMap.component';

let reportMapModule = angular.module('reportMap', [
  uiRouter
])

// .config(($stateProvider) => {
//   "ngInject";
//   $stateProvider
//   .state('reportMap', {
//     url: '/reportMap',
//     component: 'reportMap'
//   });
// })

.component('reportMap', reportMapComponent)

.name;

export default reportMapModule;



// WEBPACK FOOTER //
// ./client/app/common/reportMap/reportMap.js